import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/stock-count-entries', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/stock-count-entries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/stock-count-entries/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/stock-count-entries/${data.stock_count_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/stock-count-entries/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const getProduct = (Option = {}) => {
  return httpClient
    .get(
      '/api/products?page=-1&fields[setup_inventory_products]=product_id,product_name_en,barcode'
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSystemQty = (product_id, Option = {}) => {
  return httpClient
    .get(`/api/stock-count-entries/system-quantities/${product_id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  getProduct,
  getSystemQty
}
